//React
import React from "react";
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as articlesAction from '../action/articlesAction';

//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
//Add
import Masonry from 'react-masonry-component';
import { LazyLoadImage } from 'react-lazy-load-image-component';
//Part
import PartPageTitle from './PartPageTitle';
import PartPagingNextPrev from './PartPagingNextPrev';
//Dialog
//img

import Blank2x1 from '../img/blank/blank-2x1.gif';

class Comp extends React.Component {

  componentDidMount() {
    document.title = 'コラム - パートナーズ';
    if ( ((new Date()) - this.props.articles.datetime) > (86400*1000) ) {
      this.props.articlesListGet(null, 1);
    }
  }

  _onCategory(category) {
    this.props.articlesListGet(category, 1);
  }

  _onPaging(page) {
    this.props.articlesListGet(this.props.articles.category.en, page);
    window.scrollTo(0, 0);
  }


  _renderBreadcrumb = (item, index) => {
    return (
      <span key={index} style={{display:'inline-block', margin:'3px'}}>
        <span
          onClick={ () => this.props.articlesListGet(item.category_en, 1) }
          style={{cursor:'pointer'}}
        >
          { item.category_name }
        </span>
      </span>
    );
  };

  _renderCategory = (item, index) => {
		return (
			<span key={index} style={{display:'inline-block', margin:'3px'}}>
        <Button
          variant="outlined"
          onClick={ () => this._onCategory(item.category_en) }
        >
				  { item.category_name }
        </Button>
			</span>
		);
	};

	_renderList = (item, index) => {
		return (
			<div key={index} className='box_outer'>
				<Box className='box_inner round12' boxShadow={2}>
          <Link to={{ pathname: '/articles/id-' + item.articles_id}}>

            <LazyLoadImage
              src={'//cdn.partner-s.net/articles/?file=' + item.articles_img + "&W=400&H=200&crop=1"}
              style={{width:"100%", height: "auto", boxSizing:'border-box'}}
              placeholder={<img src={Blank2x1} style={{width:"100%", height: "auto",}} alt='' />}
              alt=''
            />

            <div style={{padding:'2%'}}>
              <div style={{color:'#333'}}>{item.articles_title}</div>

  						<div style={{fontSize:'0.9em' ,color:'#999',}}>
                {item.category_name}
              </div>
  					</div>
          </Link>
				</Box>

			</div>
		);
	};




	render() {

		return (
      <div>
        <Breadcrumbs style={{margin:'3px'}}>
        {
          this.props.articles.breadcrumb.map(
            (value, index) => this._renderBreadcrumb(value, index)
          )
        }
        </Breadcrumbs>
        {
          (this.props.articles.category.id) ? (
            <PartPageTitle
              title={this.props.articles.category.ja}
            />
          ) : (
            <PartPageTitle
              title={'婚活・恋愛コラム'}
            />
          )

        }
        <div style={{margin:'3px',textAlign:'center'}}>
          {
            this.props.articles.childCategory.map(
              (value, index) => this._renderCategory(value, index)
            )
          }
        </div>
        <div id='articles_list_block'>

  				<Masonry options={
  					{
  						itemSelector: '.box_outer',
  						transitionDuration: 0,
  					}
  				}>
  	        {
  						this.props.articles.list.map(
  	          	(value, index) => this._renderList(value, index)
  	        	)
  					}
  				</Masonry>

      	</div>
        <div style={{margin:'15px'}}>
          <PartPagingNextPrev
            page={this.props.articles.page}
            isNext={this.props.articles.isListNext}
            onClick={ (e) => this._onPaging(e) }
          />
        </div>


      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		articles: state.articles,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...articlesAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
